import React, { useEffect, useState } from 'react';

const CONSENT_COOKIE = 'privacy_consent';
export const CONSENT_VERSION = 'v1';

export function getCookie(name) {
  try {
    const m = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return m ? decodeURIComponent(m[2]) : null;
  } catch (_) { return null; }
}

export function parseConsent(raw) {
  if (!raw) return null;
  const [version, n, a] = String(raw).split(':');
  if (!version) return null;
  return { version, necessary: n === '1', analytics: a === '1' };
}

async function postConsent(necessary, analytics) {
  await fetch('/api/consent', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ necessary, analytics })
  });
  window.location.reload();
}

const PrivacyBanner = () => {
  const [show, setShow] = useState(false);
  const [dnt, setDnt] = useState(false);

  useEffect(() => {
    const c = parseConsent(getCookie(CONSENT_COOKIE));
    // Show banner if consent missing/outdated OR necessary not accepted
    const hasValidNecessary = !!c && c.version === CONSENT_VERSION && c.necessary === true;
    setShow(!hasValidNecessary);
    try {
      const d = (navigator && (navigator.doNotTrack === '1' || navigator.msDoNotTrack === '1')) || (window && window.doNotTrack === '1');
      setDnt(!!d);
    } catch (_) { setDnt(false); }
  }, []);

  if (!show) return null;

  const green = '#28a745';
  const beige = '#f5f0f0';

  return (
    <div
      style={{
        position: 'fixed',
        left: 16,
        right: 16,
        bottom: 88, // sit above footer on mobile/desktop
        margin: '0 auto',
        maxWidth: 720,
        width: 'calc(100% - 32px)',
        background: beige,
        border: `1px solid ${green}`,
        borderRadius: 16,
        padding: 16,
        boxShadow: '0 10px 20px rgba(0,0,0,.1)',
        zIndex: 9999
      }}
    >
      <div style={{ fontWeight: 700, fontSize: 16, color: '#1f3a1f' }}>Your privacy choices</div>
      <div style={{ marginTop: 6, fontSize: 14, color: '#2c3e2c' }}>
        We use necessary cookies for sign‑in and basic site functionality.
        Optional analytics help us improve the product. You can see further details about our use of cookies and change your choice anytime on the Cookies page.
        <a href="/cookies" style={{ marginLeft: 6, color: '#1f3a1f', textDecoration: 'underline' }}>Learn more</a>.
        {dnt && (
          <div style={{ marginTop: 6, fontSize: 12, color: '#1f3a1f' }}>
            Your browser's 'Do Not Track' is enabled. Analytics are off by default unless you opt in.
          </div>
        )}
      </div>
      <div style={{ display: 'flex', gap: 8, marginTop: 12, flexWrap: 'wrap' }}>
        <button
          onClick={() => postConsent(true, false)}
          style={{
            border: `1px solid ${green}`,
            color: green,
            borderRadius: 16,
            padding: '8px 12px',
            background: '#fff',
            flex: '1 1 200px'
          }}
        >
          Accept necessary only
        </button>
        <button
          onClick={() => postConsent(true, true)}
          style={{
            border: `1px solid ${green}`,
            background: green,
            color: '#fff',
            borderRadius: 16,
            padding: '8px 12px',
            flex: '1 1 200px'
          }}
        >
          Accept necessary + analytics
        </button>
        <button
          onClick={() => postConsent(false, false)}
          style={{
            marginLeft: 'auto',
            background: 'none',
            border: 'none',
            textDecoration: 'underline',
            color: '#2c3e2c',
            flex: '0 0 auto'
          }}
        >
          Reject all
        </button>
      </div>
    </div>
  );
};

export default PrivacyBanner;


